import { useState } from 'react';

const STORAGE_KEY = 'ateneu_admin_config';

const DEFAULTS = {
  adminPassword: 'ateneu2024',
  speech: { lang: 'es-ES', rate: 0.8, volume: 1.0 },
  webhookUrl: 'https://automatizacion.aigencia.ai/webhook/facial-recognition',
  editWebhookUrl: '',
  addFaceWebhookUrl: '',
  deleteFaceWebhookUrl: '',
  listFacesWebhookUrl: '',
  resetTimeoutSeconds: 15,
  retryDelaySeconds: 5,
  captureIntervalSeconds: 2,
  autoScanEnabled: true,
};

function deepMerge(base, patch) {
  const result = { ...base };
  for (const key of Object.keys(patch)) {
    if (patch[key] && typeof patch[key] === 'object' && !Array.isArray(patch[key])) {
      result[key] = deepMerge(base[key] || {}, patch[key]);
    } else {
      result[key] = patch[key];
    }
  }
  return result;
}

export function useConfig() {
  const [config, setConfig] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? deepMerge(DEFAULTS, JSON.parse(stored)) : DEFAULTS;
    } catch {
      return DEFAULTS;
    }
  });

  const updateConfig = (patch) => {
    setConfig(prev => {
      const next = deepMerge(prev, patch);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  return { config, updateConfig };
}
